
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiModelAdd extends Vue {
  private modalShow = false;
  private loading = true;
  private modalTitle = i18n.t("ratamanage.delayRateDetails");

  private delayFreeMinutes = 0;
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("ratamanage.slotDelayPrice"),
      key: "slotDelayPrice",
      resizable: true,
      minWidth: 260
    },
    {
      title: i18n.t("addRatamanage.timeValue"),
      key: "time",
      resizable: true,
      width: 500
    }
  ];
  public open(item: objAny) {
    this.modalShow = true;
    this.delayFreeMinutes = item.delayFreeMinutes;
    const list = item.oprDelayFeeInfos;
    let time: string[] = [];
    list.map((unit: objAny) => {
      time = [unit.beginTime, unit.endTime];
      unit.time = this.joinDate(time);
    });
    this.tableList = list;
  }
  /**
   * 把例如1230转为12:30
   * @param data 08：00
   * @param processData
   */
  convertStringToTimes(data: string | number) {
    const hour = String(Math.floor(Number(data) / 100)).padStart(2, "0");
    const min = String(Number(data) % 100).padStart(2, "0");
    const time = hour + ":" + min;
    return time;
  }
  /**
   * 合并时间 08:00-12:00
   */
  joinDate(data: string[]) {
    let timeArr = "";
    if (data.length > 0) {
      timeArr =
        this.convertStringToTimes(data[0]) +
        "-" +
        this.convertStringToTimes(data[1]);
      return timeArr;
    }
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  mounted() {
    this.$emit("getChild", this);
  }
}
